import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Creators } from './duck/actions';

import adTissot from '../../assets/images/ad-tissot.png';
import adSuggested from '../../assets/images/ad-suggested.png';
import adSeparator from '../../assets/images/ad-separator.png';
import adShop from '../../assets/images/ad-shop.png';

import Banner from '../common/Banner/Banner';
import AdBanner from '../common/AdBanner/AdBanner';

import LatestReviews from '../common/ListWithImage/List_Show_More';
import OuterBox from '../common/OuterBox/OuterBox';
import InnerBox from '../common/InnerBox/InnerBox';

import adLinkedin from '../../assets/images/ad-linkedin.png';
import adAmazon from '../../assets/images/ad-amazon.png';
// import adSuggestedVertical from '../../assets/images/ad-suggested-vertical.png';
import adAmazonVertical from '../../assets/images/ad-amazon-vertical.png';

import {
  // Title,
  // StyledLine,
  // StyledLineInside,
  ListElement,
  Image,
  FlexContainer
} from '../common/StyledComponents';
import { SideBar } from '../common/StyledComponents/StyledSideBar';
import List_XS_Image from '../common/ListWithImage/List_XS_Image';
import List_S_Image from '../common/ListWithImage/List_S_Image';
import List_M_Image from '../common/ListWithImage/List_M_Image';
import BannerLoader from '../common/Loaders/BannerLoader';

class Reviews extends Component {
  componentWillMount = () => {
    // console.log('[Reviews.js] componentWillMount');
    window.scrollTo(0, 0);
  };

  componentDidMount = () => {
    // console.log('[Reviews.js] - CDM');
    // console.log('[Reviews.js] componentDidMount');
    this.props.onFetchReviewsBanner();
    this.props.onFetchLatestReviews(1);

    this.props.onFetchTopReviews();
    // Fetch Laptops, Mobiles, Cameras, Accessories
    this.props.onFetchLaptops();
    this.props.onFetchMobiles();
    this.props.onFetchCameras();
    this.props.onFetchAccessories();
    // Fetch Best Of Laptops, Mobiles, Cameras, Accessories
    this.props.onFetchBestOfLaptops();
    this.props.onFetchBestOfMobiles();
    this.props.onFetchBestOfCameras();
    this.props.onFetchBestOfAccessories();
  };

  componentDidUpdate = (prevProps, prevState) => {
    // console.log(`[Reviews.js] componentDidUpdate`);
    // Make API requests according to the page that needs to be fetched.
  };

  handleLoadMore = () => {
    console.log('Handle Load More');
    this.props.onFetchLatestReviews(this.props.pageForLatestReviews);
  };

  navigate = postSlug => {
    // console.log('postSlug: ', postSlug);
    this.props.history.push(`/${postSlug}`);
  };

  render() {
    return (
      <div
        className="Reviews w-100"
        // style={{
        // width: '100%'
        // maxWidth: '1440px'
        // }}
      >
        <AdBanner height="250px" width="970px" margin="1rem 0">
          <Image src={adTissot} width="100%" height="100%" alt="tissot ad" />
        </AdBanner>

        {this.props.reviewsBannerData ? (
          <Banner
            bannerData={this.props.reviewsBannerData}
            clicked={this.navigate}
          />
        ) : (
          <BannerLoader />
        )}

        <FlexContainer className="mt3 mh2 justify-center">
          <AdBanner height="91px" width="730px">
            <Image
              src={adSeparator}
              width="100%"
              height="100%"
              alt="tissot ad"
            />
          </AdBanner>
        </FlexContainer>

        <OuterBox>
          <InnerBox padding="1.2rem">
            <LatestReviews
              title="Latest Reviews"
              contentData={this.props.latestReviews}
              handleLoadMore={this.handleLoadMore}
              clicked={this.navigate}
              showMore={true}
            />

            <SideBar>
              <AdBanner height="600px" width="300px" margin="18px 0 18px 0">
                <Image
                  src={adAmazonVertical}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
              {/* {this.props.topReviews ? ( */}
              {
                // eslint-disable-next-line
                <List_S_Image
                  title="Top Reviews"
                  listItems={this.props.topReviews}
                />
              }
              {/* ) : null} */}
            </SideBar>
          </InnerBox>
        </OuterBox>

        <AdBanner
          height="250px"
          width="970px"
          // margin="18px 0"
        >
          <Image src={adTissot} width="100%" height="100%" alt="tissot ad" />
        </AdBanner>

        {/* Include Best Laptops, etc here */}
        <OuterBox>
          <InnerBox>
            <FlexContainer direction="column">
              {this.props.laptops ? (
                // eslint-disable-next-line
                <List_M_Image
                  className="List_M_Image mb3"
                  title="Laptops"
                  listItems={this.props.laptops}
                />
              ) : null}

              <AdBanner height="91px" width="730px" margin="0 0 1rem 0">
                <Image
                  src={adShop}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>

              {this.props.mobiles ? (
                // eslint-disable-next-line
                <List_M_Image
                  className="List_M_Image mb3"
                  title="Mobiles"
                  listItems={this.props.mobiles}
                />
              ) : null}

              {this.props.cameras ? (
                // eslint-disable-next-line
                <List_M_Image
                  className="List_M_Image mb3"
                  title="Cameras"
                  listItems={this.props.cameras}
                />
              ) : null}

              <AdBanner height="91px" width="730px" margin="0 0 1rem 0">
                <Image
                  src={adSeparator}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>

              {this.props.accessories ? (
                // eslint-disable-next-line
                <List_M_Image
                  // className="List_M_Image mb3"
                  className="List_M_Image"
                  title="Accessories"
                  listItems={this.props.accessories}
                />
              ) : null}
            </FlexContainer>

            <SideBar>
              {this.props.bestOfLaptops ? (
                // eslint-disable-next-line
                <List_XS_Image
                  className="List_XS_Image mb3"
                  title="Best of Laptops"
                  listItems={this.props.bestOfLaptops}
                />
              ) : null}
              <AdBanner height="250px" width="300px" margin="0 0 1rem 0">
                <Image
                  src={adLinkedin}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
              {this.props.bestOfMobiles ? (
                // eslint-disable-next-line
                <List_XS_Image
                  className="List_XS_Image mb3"
                  title="Best of Mobiles"
                  listItems={this.props.bestOfMobiles}
                />
              ) : null}
              <AdBanner height="250px" width="300px" margin="0 0 1rem 0">
                <Image
                  src={adAmazon}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
              {this.props.bestOfCameras ? (
                // eslint-disable-next-line
                <List_XS_Image
                  className="List_XS_Image mb3"
                  title="Best of Cameras"
                  listItems={this.props.bestOfCameras}
                />
              ) : null}
              {/* <AdBanner height="565px" width="300px" margin="0.5rem 0">
                <Image
                  src={adSuggestedVertical}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner> */}
              {this.props.bestOfAccessories ? (
                // eslint-disable-next-line
                <List_XS_Image
                  className="List_XS_Image mb3"
                  title="Best of Accessories"
                  listItems={this.props.bestOfAccessories}
                />
              ) : null}
            </SideBar>
          </InnerBox>
        </OuterBox>

        <OuterBox>
          <InnerBox>
            <ListElement className="w-100" maxwidth="100%" padding="20px">
              {/* <Title
                fontFamily="Montserrat"
                fontSize="1.5rem"
                fontWeight="bold"
              >
                Suggested
              </Title>
              <StyledLine>
                <StyledLineInside />
              </StyledLine> */}
              {/* <AdBanner height="210px" width="1000px" margin="0"> */}
              <AdBanner height="346px" width="1040px" margin="0">
                <Image
                  src={adSuggested}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
            </ListElement>
          </InnerBox>
        </OuterBox>
      </div>
    );
  }
}

const mapStateToProps = state => {
  // console.log('state: ', state);
  return {
    loading: state.news.loading,
    reviewsBannerData: state.reviews.reviewsBannerData,
    latestReviews: state.reviews.latestReviews,
    pageForLatestReviews: state.reviews.pageForLatestReviews,
    topReviews: state.reviews.topReviews,
    laptops: state.reviews.laptops,
    mobiles: state.reviews.mobiles,
    cameras: state.reviews.cameras,
    accessories: state.reviews.accessories,
    bestOfLaptops: state.reviews.bestOfLaptops,
    bestOfMobiles: state.reviews.bestOfMobiles,
    bestOfCameras: state.reviews.bestOfCameras,
    bestOfAccessories: state.reviews.bestOfAccessories
  };
};

const mapDispatchToProps = dispatch => ({
  onFetchReviewsBanner: () => dispatch(Creators.fetchReviewsBanner()),
  onFetchLatestReviews: page => dispatch(Creators.fetchLatestReviews(page)),
  onFetchTopReviews: () => dispatch(Creators.fetchTopReviews()),
  onFetchLaptops: () => dispatch(Creators.fetchLaptops()),
  onFetchMobiles: () => dispatch(Creators.fetchMobiles()),
  onFetchCameras: () => dispatch(Creators.fetchCameras()),
  onFetchAccessories: () => dispatch(Creators.fetchAccessories()),
  onFetchBestOfLaptops: () => dispatch(Creators.fetchBestOfLaptops()),
  onFetchBestOfMobiles: () => dispatch(Creators.fetchBestOfMobiles()),
  onFetchBestOfCameras: () => dispatch(Creators.fetchBestOfCameras()),
  onFetchBestOfAccessories: () => dispatch(Creators.fetchBestOfAccessories())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Reviews);
